import { Injectable, inject } from '@angular/core';
import { BrandonService } from './brandon.service';
import { IPartnerService } from '../../interfaces/partner-services';
import { ArgoService } from './argo.service';

export const ARGO_PLATFORM_SLUGS = ['argo.ot4.dev', 'web.watchargo.com'];
export const BRANDON_PLATFORM_SLUGS = ['brandon.ot4.dev', 'itsbrandontv.live'];

@Injectable({
  providedIn: 'root',
})
export class PartnerServiceFactory {
  private argoService = inject(ArgoService);
  private brandonService = inject(BrandonService);

  getService(platformSlug: string): IPartnerService {
    if (ARGO_PLATFORM_SLUGS.includes(platformSlug)) {
      return this.argoService;
    }

    if (BRANDON_PLATFORM_SLUGS.includes(platformSlug)) {
      return this.brandonService;
    }

    return null;
  }
}
